export default {"src":"/_next/static/media/whole-yard.1c5f67ef.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};